import { Controller, Application } from 'stimulus';
import { checkPasswordRequirements } from './../account-service';
import $ from 'jquery';
import 'jquery-validation';

class SignUpFormController extends Controller {
  static targets = ['backendErrorSummary', 'clientErrorSummary', 'email', 'password'];

  private validator?: JQueryValidation.Validator;
  private declare readonly backendErrorSummaryTarget: HTMLElement;
  private declare readonly clientErrorSummaryTarget: HTMLElement;
  private declare readonly emailTarget: HTMLInputElement;
  private declare readonly passwordTarget: HTMLInputElement;

  initialize(): void {
    $.validator.addMethod(
      'password',
      (value: string) => {
        return checkPasswordRequirements(value);
      },
      'Please enter a stronger password'
    );
  }

  connect(): void {
    this.validator = $(this.element).validate({
      errorLabelContainer: `#${this.clientErrorSummaryTarget.id}`,
      wrapper: 'li',
      rules: {
        Email: {
          required: true,
          email: true,
          remote: {
            url: '/pages/account/check-user-registration',
            type: 'post',
            dataFilter(isUserRegisteredResponse: string) {
              interface CheckUserRegistrationResponseModel {
                isUserRegistered: boolean;
              }
              const obj = JSON.parse(isUserRegisteredResponse) as CheckUserRegistrationResponseModel;
              return !obj.isUserRegistered;
            }
          }
        },
        Password: {
          required: true,
          password: true
        }
      },
      messages: {
        Email: {
          required: 'Please enter your email',
          email: 'Please enter a valid email address',
          remote: 'The email is already used'
        },
        Password: {
          required: 'Please enter your password'
        }
      },
      // Hide backend validation errors on focus in
      onfocusin: () => {
        this.backendErrorSummaryTarget.style.display = 'none';
      },
      // Validate everything on focus out
      onfocusout: (element: HTMLElement) => {
        $(element).valid();
      },
    });

    // Dirty hack to avoid iOS autofocusing HALO-16638
    this.removeTabIndex();
  }

  private removeTabIndex() {
    this.emailTarget.removeAttribute('tabindex');
    this.passwordTarget.removeAttribute('tabindex');
  }
}

export function registerSignUpFormController(application: Application): void {
  application.register('signUpForm', SignUpFormController);
}
